module.exports = __webpack_public_path__ + "img/shovel.a86dc5f1.svg";